import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../../api/axios';
import useAuthStore from '../../store/authStore';

export default function DoctorDashboard() {
  const { user, logout } = useAuthStore();
  const navigate = useNavigate();
  const [stats, setStats] = useState(null);
  const [today, setToday] = useState([]);

  useEffect(() => {
    api.get('/doctor/stats').then(r => setStats(r.data));
    api.get('/appointments/today').then(r => setToday(r.data));
  }, []);

  const handleLogout = async () => {
    try { await api.post('/auth/logout'); } catch(e) {}
    logout(); navigate('/login');
  };

  const statusColor = (s) => ({
    pending:'bg-yellow-100 text-yellow-700',
    confirmed:'bg-green-100 text-green-700',
    completed:'bg-blue-100 text-blue-700',
  }[s] || 'bg-gray-100 text-gray-700');

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-white border-b px-4 py-3 flex items-center justify-between sticky top-0 z-10">
        <div className="flex items-center gap-2">
          <span className="text-2xl">🏥</span>
          <span className="font-bold text-green-700">SantéTogo</span>
        </div>
        <button onClick={handleLogout} className="text-sm text-red-500">Déconnexion</button>
      </div>

      <div className="max-w-lg mx-auto p-4 space-y-4">
        <div>
          <h2 className="font-bold text-xl text-gray-800">Bonjour, Dr {user?.name?.split(' ').slice(-1)[0]} 👋</h2>
          <p className="text-sm text-gray-500">{new Date().toLocaleDateString('fr-FR', {weekday:'long', day:'numeric', month:'long'})}</p>
        </div>

        {/* Stats */}
        {stats && (
          <div className="grid grid-cols-2 gap-3">
            {[
              {label:'RDV Total', value: stats.total_appointments, icon:'📅'},
              {label:'Patients', value: stats.total_patients, icon:'👥'},
              {label:'En attente', value: stats.pending_appointments, icon:'⏳'},
              {label:'Revenus', value: parseInt(stats.total_revenue||0).toLocaleString()+' FCFA', icon:'💰'},
            ].map(s => (
              <div key={s.label} className="card text-center">
                <div className="text-2xl mb-1">{s.icon}</div>
                <div className="font-bold text-lg text-gray-800">{s.value}</div>
                <div className="text-xs text-gray-500">{s.label}</div>
              </div>
            ))}
          </div>
        )}

        {/* Actions */}
        <div className="grid grid-cols-2 gap-3">
          <Link to="/doctor/appointments" className="card flex flex-col items-center py-4 hover:border-green-300 transition-all">
            <span className="text-2xl mb-1">📋</span>
            <span className="text-sm font-semibold text-gray-700">Mes RDV</span>
          </Link>
          <Link to="/doctor/availability" className="card flex flex-col items-center py-4 hover:border-green-300 transition-all">
            <span className="text-2xl mb-1">🕐</span>
            <span className="text-sm font-semibold text-gray-700">Disponibilités</span>
          </Link>
          <Link to="/doctor/profile" className="card flex flex-col items-center py-4 hover:border-green-300 transition-all">
            <span className="text-2xl mb-1">👤</span>
            <span className="text-sm font-semibold text-gray-700">Mon profil</span>
          </Link>
          <Link to="/doctor/patients" className="card flex flex-col items-center py-4 hover:border-green-300 transition-all">
            <span className="text-2xl mb-1">👥</span>
            <span className="text-sm font-semibold text-gray-700">Patients</span>
          </Link>
        </div>

        {/* RDV du jour */}
        <div className="card">
          <h3 className="font-bold text-gray-800 mb-3">Rendez-vous aujourd'hui ({today.length})</h3>
          {today.length === 0 ? (
            <p className="text-gray-400 text-sm text-center py-4">Aucun rendez-vous aujourd'hui</p>
          ) : (
            <div className="space-y-2">
              {today.map(apt => (
                <div key={apt.id} className="flex items-center justify-between p-3 bg-gray-50 rounded-xl">
                  <div>
                    <p className="font-semibold text-sm">{apt.patient?.name}</p>
                    <p className="text-xs text-gray-500">{new Date(apt.scheduled_at).toLocaleTimeString('fr-FR', {hour:'2-digit',minute:'2-digit'})} • {apt.type === 'in_person' ? 'Cabinet' : 'Vidéo'}</p>
                  </div>
                  <span className={`text-xs px-2 py-1 rounded-full font-medium ${statusColor(apt.status)}`}>
                    {apt.status === 'pending' ? 'En attente' : apt.status === 'confirmed' ? 'Confirmé' : 'Terminé'}
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
